import { defineStore } from 'pinia'
import http from '../http'
import router from '@/router'

export const useOrdersStore = defineStore('orders', {
  state: () => {
    return {
      actionRequired: [],
      loading: false,
      loadingPhase: false,
      fileUploads: [],
      orders: {
        orders_with_actions: [],
        orders_without_actions: [],
        my_orders: [],
        my_orders_with_actions: [],
        my_orders_without_actions: [],
        active: [],
        completed: [],
        unactive: [],
        archived: [],
        deleted: [],
      },
      loadingStates: {
        orders_with_actions: false,
        orders_without_actions: false,
        my_orders: false,
        my_orders_with_actions: false,
        my_orders_without_actions: false,
        active: false,
        completed: false,
        unactive: false,
        archived: false,
        deleted: false,
      },
      order: undefined,
      query: {
        search: null,
        filters: [],
        sorts: [],
        my_orders: false,
      },
      pagination: {
        orders_with_actions: {
          current_page: 1,
        },
        orders_without_actions: {
          current_page: 1,
        },
        my_orders: {
          current_page: 1,
        },
        my_orders_with_actions: {
          current_page: 1,
        },
        my_orders_without_actions: {
          current_page: 1,
        },
        active: {
          current_page: 1,
        },
        completed: {
          current_page: 1,
        },
        unactive: {
          current_page: 1,
        },
        archived: {
          current_page: 1,
        },
        deleted: {
          current_page: 1,
        },
      },

      ridderSyncLoading: false,

      updateLoading: false,
    }
  },
  actions: {
    fetchDebounceAll() {
      this.getOrders()
      this.getOrdersWithActions()
      this.getOrdersWithoutActions()
      this.getToBeActivatedOrders()
      this.getArchivedOrders()
      this.getCompletedOrders()
      this.getDeletedOrders()
    },
    fetchDebounceUser() {
      this.getOrders()
      this.getCompletedOrders()
    },
    getOrders(filterParams) {
      this.loading = true
      let order = ''
      const urlSearchString = new URLSearchParams()
      if (this.query.search)
        urlSearchString.append('search', this.query.search)

      if (filterParams && filterParams.order) {
        if (filterParams.order === 'ascend')
          order = 'asc'

        else
          order = 'desc'

        urlSearchString.append(`sorts[${filterParams.columnKey}]`, order)
      }
      urlSearchString.append('page', this.pagination.active.current_page)
      return http
        .get(`api/orders/active?${urlSearchString}`)
        .then((response) => {
          this.orders.active = response.data.data
          this.pagination.active = response.data.pagination
        })
        .finally(() => {
          this.loading = false
        })
    },
    getOrdersWithActions(filterParams) {
      this.loading = true
      this.loadingStates.orders_with_actions = true
      let order = ''
      const urlSearchString = new URLSearchParams()
      if (this.query.search)
        urlSearchString.append('search', this.query.search)

      if (filterParams && filterParams.order) {
        if (filterParams.order === 'ascend')
          order = 'asc'

        else
          order = 'desc'

        urlSearchString.append(`sorts[${filterParams.columnKey}]`, order)
      }
      urlSearchString.append('page', this.pagination.orders_with_actions.current_page)
      urlSearchString.append('action_required', 1)
      if (this.query.my_orders)
        urlSearchString.append('my_orders', 1)

      return http
        .get(`api/orders/active?${urlSearchString}`)
        .then((response) => {
          this.orders.orders_with_actions = response.data.data
          this.pagination.orders_with_actions = response.data.pagination
        })
        .finally(() => {
          this.loading = false
          this.loadingStates.orders_with_actions = false
        })
    },
    getOrdersWithoutActions(filterParams) {
      this.loading = true
      this.loadingStates.orders_without_actions = true

      let order = ''
      const urlSearchString = new URLSearchParams()
      if (this.query.search)
        urlSearchString.append('search', this.query.search)

      if (filterParams && filterParams.order) {
        if (filterParams.order === 'ascend')
          order = 'asc'

        else
          order = 'desc'

        urlSearchString.append(`sorts[${filterParams.columnKey}]`, order)
      }
      urlSearchString.append('page', this.pagination.orders_without_actions.current_page)
      urlSearchString.append('action_required', 0)
      if (this.query.my_orders)
        urlSearchString.append('my_orders', 1)

      return http
        .get(`api/orders/active?${urlSearchString}`)
        .then((response) => {
          this.orders.orders_without_actions = response.data.data
          this.pagination.orders_without_actions = response.data.pagination
        })
        .finally(() => {
          this.loading = false
          this.loadingStates.orders_without_actions = false
        })
    },
    getToBeActivatedOrders(filterParams) {
      this.loading = true
      this.loadingStates.unactive = true
      let order = ''
      const urlSearchString = new URLSearchParams()
      if (this.query.search)
        urlSearchString.append('search', this.query.search)

      if (filterParams && filterParams.order) {
        if (filterParams.order === 'ascend')
          order = 'asc'
        else
          order = 'desc'

        urlSearchString.append(`sorts[${filterParams.columnKey}]`, order)
      }
      urlSearchString.append('page', this.pagination.unactive.current_page)

      return http
        .get(`/api/orders/to-be-activated?${urlSearchString}`)
        .then((response) => {
          this.orders.unactive = response.data.data
          this.pagination.unactive = response.data.pagination
        })
        .finally(() => {
          this.loading = false
          this.loadingStates.unactive = false
        })
    },
    getArchivedOrders(filterParams) {
      this.loading = true
      this.loadingStates.archived = true
      let order = ''
      const urlSearchString = new URLSearchParams()
      if (this.query.search)
        urlSearchString.append('search', this.query.search)

      if (filterParams && filterParams.order) {
        if (filterParams.order === 'ascend')
          order = 'asc'

        else
          order = 'desc'

        urlSearchString.append(`sorts[${filterParams.columnKey}]`, order)
      }
      urlSearchString.append('page', this.pagination.unactive.current_page)
      return http
        .get(`/api/orders/archived?${urlSearchString}`)
        .then((response) => {
          this.orders.archived = response.data.data
          this.pagination.archived = response.data.pagination
        })
        .finally(() => {
          this.loading = false
          this.loadingStates.archived = false
        })
    },
    getCompletedOrders(filterParams) {
      this.loading = true
      this.loadingStates.completed = true
      let order = ''
      const urlSearchString = new URLSearchParams()
      if (this.query.search)
        urlSearchString.append('search', this.query.search)

      if (filterParams && filterParams.order) {
        if (filterParams.order === 'ascend')
          order = 'asc'

        else
          order = 'desc'

        urlSearchString.append(`sorts[${filterParams.columnKey}]`, order)
      }
      urlSearchString.append('page', this.pagination.completed.current_page)
      return http
        .get(`/api/orders/completed?${urlSearchString}`)
        .then((response) => {
          this.orders.completed = response.data.data
          this.pagination.completed = response.data.pagination
        })
        .finally(() => {
          this.loading = false
          this.loadingStates.completed = false
        })
    },
    getDeletedOrders(filterParams) {
      this.loading = true
      this.loadingStates.deleted = true
      let order = ''
      const urlSearchString = new URLSearchParams()
      if (this.query.search)
        urlSearchString.append('search', this.query.search)

      if (filterParams && filterParams.order) {
        if (filterParams.order === 'ascend')
          order = 'asc'

        else
          order = 'desc'

        urlSearchString.append(`sorts[${filterParams.columnKey}]`, order)
      }
      urlSearchString.append('page', this.pagination.deleted.current_page)
      return http
        .get(`/api/orders/deleted?${urlSearchString}`)
        .then((response) => {
          this.orders.deleted = response.data.data
          this.pagination.deleted = response.data.pagination
        })
        .finally(() => {
          this.loading = false
          this.loadingStates.deleted = false
        })
    },
    forgetOrder() {
      this.order = undefined;
    },
    getOrder(id, skipLoading = false) {
      if (!skipLoading)
        this.loading = true
      else this.loading = false
      this.order = undefined
      return http
        .get(`/api/orders/${id}`)
        .then((response) => {
          this.order = response.data
          this.loading = false
        })
    },
    orderHasPhaseId(phaseId) {
      if (this.order) {
        const phaseIds = this.order.phases.map((phase) => {
          return phase.id;
        });
        return phaseIds.includes(phaseId)
      } else {
        return false
      }
    },
    syncOrder(id) {
      this.loading = true
      return http
        .patch(`/api/orders/${id}/sync`)
        .then(() => this.getOrder(id))
        .finally(() => this.loading = false)
    },
    archiveOrder(id) {
      this.loading = true
      return http
        .patch(`/api/orders/${id}/archive`)
        .then(() => {
          this.getOrder(id)
        })
        .finally(() => {
          this.loading = false
        })
    },
    activateOrder(id) {
      this.loading = true
      return http
        .patch(`/api/orders/${id}/activate`)
        .then(() => {
          this.getOrder(id)
        })
        .finally(() => {
          this.loading = false
        })
    },
    completeOrder(id) {
      this.loading = true
      return http
        .post(`/api/orders/${id}/mark-complete`)
        .then((response) => {
          this.getOrder(id)
          return response
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeTemplate(id, newTemplateId) {
      if (newTemplateId) {  
        this.loading = true
        return http.post(`/api/orders/${id}/change-template/${newTemplateId}`)
        .then(async(_) => {
          await this.getOrder(id)
          router.replace({
            path: `/dossiers/${id}`
          })
          this.loading = false
        })
      } else {
        console.error("no template is selected, so change-template is not possible")
      }
    },
    uncompleteOrder(id) {
      this.loading = true
      return http
        .post(`/api/orders/${id}/mark-complete?complete=false`)
        .then((response) => {
          this.getOrder(id)
          return response
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateOrder(id, data, skipLoading = false) {
      if (!skipLoading)
        this.updateLoading = true
      else this.updateLoading = false
      return http.patch(`/api/orders/${id}`, data).finally(() => {
        this.updateLoading = false
      })
    },
    moveOrderToBin(id) {
      return http.delete(`/api/orders/${id}`)
    },
    restoreOrderFromBin(orderData) {
      const data = {
        product_id: orderData.product_id,
        serial_number: orderData.serial_number,
        invoice_address: {
          street: orderData.invoice_address,
        },
        title: orderData.title,
      }
      return http.post(`/api/orders/${orderData.id}/restore`, data)
    },
    syncWithRidder() {
      this.ridderSyncLoading = true
      return http.get('/api/orders/sync_ridder').then((response) => {
        window.$message.success(response.data.message)
      }).finally(() => {
        this.ridderSyncLoading = false
      })
    },
    createFileObject(file) {
      console.log('createFileObject', file)
      return {
        created_at: new Date(),
        custom_properties: [],
        file_name: file.name,
        language: null,
        meta: null,
        original_path: null,
        path: null,
      }
    },
    getRequiredActions() {
      return http.get('api/checklists/action-required')
        .then((response) => {
          this.requiredActions = response.data.data
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  getters: {

  },
  debounce: {
    fetchDebounceAll: 400,
    fetchDebounceUser: 400,
  },
})
